setTimeout(function () {
  

let gemProdOptions,legend,colorOptions;
const colorOptionRadios = document.querySelectorAll('#gmus6YbfxW input')
    console.log(colorOptionRadios)
function init() {
gemProdOptions = document.querySelectorAll('.option-item-inner');
legend = document.querySelectorAll('legend')[0];
colorOptions = document.querySelector('#gmus6YbfxW');
}

init();

const hideShowColorOptions = function () {
  init();
  if (!legend.innerHTML.includes('Frame')) {
colorOptionRadios.forEach(colorOptionRadio => {colorOptionRadio.checked = false})    
colorOptions.style.display = 'none';
} else {
colorOptions.style.display = 'block'; 
}
}
hideShowColorOptions();

gemProdOptions.forEach(gemProdOption => {
  gemProdOption.addEventListener('click',hideShowColorOptions)
})

// const updateSelectedRadio = function () {
//   console.log(this.checked);
// }

},200)

